// Motion 1.0 — element role resolver for Soft Reveal.
// Maps a canvas element into one of 5 role buckets used to pick the
// matching `soft-*` preset in ScrollEntrance.

export function getElementMotionRole(element) {
  if (!element) return 'text';
  // Explicit role from the element definition takes precedence.
  if (element.role === 'sectionBackground') return 'sectionBackground';
  if (element.role === 'paperCard')         return 'paperCard';
  if (element.role === 'photo')             return 'photo';
  if (element.role === 'imageLayer')        return 'photo';
  if (element.role === 'decorativeElement') return 'decorative';
  if (element.role === 'responseCard')      return 'paperCard';
  if (element.role === 'rsvp')              return 'paperCard';

  // Type-based fallback.
  const t = element.type;
  if (t === 'photo')             return 'photo';
  if (t === 'image')             return 'photo';
  if (t === 'rsvp')              return 'paperCard';
  if (t === 'ornament')          return 'decorative';
  if (t === 'divider')           return 'decorative';
  if (t === 'text')              return 'text';
  if (t === 'title_block')       return 'text';
  return 'text';
}

// Map a resolved role to its `soft-*` preset name (see ScrollEntrance.ANIMATIONS).
export function softPresetForRole(role) {
  switch (role) {
    case 'sectionBackground': return 'soft-bg';
    case 'paperCard':         return 'soft-paper';
    case 'photo':             return 'soft-photo';
    case 'decorative':        return 'soft-decorative';
    case 'text':
    default:                  return 'soft-text';
  }
}
